import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ 
    name: 'shorturl',
    standalone: true
})
export class ShortUrlPipe implements PipeTransform {
	transform(val: string) {
        if (!val) return '';
	    return val.replace('https://', '').replace('http://', '');
    }
}

@Pipe({ 
    name: 'decodeUrl',
    standalone: true
})
export class DecodeUrlPipe implements PipeTransform {
	transform(val: string) {
        if (!val) return '';
	    return decodeURIComponent(val);
    }
}

@Pipe({ 
    name: 'escapeHtml',
    standalone: true
})
export class EscapeHtmlPipe implements PipeTransform{
    transform(value: string) {
        
        return value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            //.replace(/"/g, "&quot;")
            //.replace(/'/g, "&#039;")

            // yikes, should be coming from the query in this format
            // but problems with COLLATION in the emoji characters
            .replace("[=globe=]", "🌍") 

            // convert \n to breaks
            .replace(/(?:\r\n|\r|\n)/g, '  \n')

    }
}






